
import { defineComponent } from 'vue';
import { Message, MessageType } from '@/shared/models/Message';

export default defineComponent({
  props: {
    message: Object,
  },
  computed: {
    flashClass(): string {
      const message = this.message as Message;
      switch (message.type) {
        case MessageType.Success:
          return 'flash-success';
        case MessageType.Warning:
          return 'flash-warning';
        case MessageType.Error:
          return 'flash-danger';
      }
      return '';
    },
  },
});
